import api from '../../../services/api';

const AXIS_KEYS = ['xAxis', 'yAxis', 'zAxis'];

/** Backend queues one Resensys PUT per axis (~6s apart). Allow 60s. */
export const ALERT_THRESHOLDS_TIMEOUT_MS = 60000;

const parseBound = (value) => {
  if (value === '' || value == null) return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
};

const assignIfNumber = (target, key, value) => {
  if (value != null) target[key] = value;
};

/**
 * Build PUT /alert-thresholds body from the settings draft.
 * Normal lower/upper → alarm_low / alarm_high
 * warning_low / warning_high are not sent.
 * If normal is empty, significant is used for alarm (Resensys mapping).
 * Empty axes are omitted.
 */
export function buildAlertThresholdsPayload(draft) {
  const payload = {};
  AXIS_KEYS.forEach((axis) => {
    const row = draft?.[axis];
    if (!row) return;
    const axisBody = {};
    assignIfNumber(axisBody, 'alarm_low', parseBound(row.normalL) ?? parseBound(row.sigL));
    assignIfNumber(axisBody, 'alarm_high', parseBound(row.normalU) ?? parseBound(row.sigU));
    if (Object.keys(axisBody).length) payload[axis] = axisBody;
  });
  return payload;
}

export function saveAlertThresholds(bridgeId, sensorId, payload) {
  return api.put(
    `/bridges/${bridgeId}/sensors/${sensorId}/alert-thresholds`,
    payload,
    { timeout: ALERT_THRESHOLDS_TIMEOUT_MS }
  );
}
